module.exports = "pegasus/assets/tech/small/5.jpg";